import {useContext, useState, useEffect} from "react";
import axios from "../../utils/api/axios";
import {AuthContext} from "../../utils/contextapi/AuthProvider";
import {useNavigate, useSearchParams} from "react-router-dom";
import { IAM_PATH, IAM_SERVER_TENANT_USER_REGIST, IAM_SERVER_UNIFIEDPROFILE } from "../../utils/Config";
import { DialogEnum, showDialog } from "../../utils/dialog/Dialog";



/**
 * 로그인 화면
 * @returns {JSX.Element}
 * @constructor
 */
function InvitePage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            alert("유효하지 않은 초대 링크입니다.");
            navigate("/login");
            return;
        }

        try {
            const decoded = JSON.parse(atob(token));

            const { email, tenantId, inviter, expires, code } = decoded;

            const url = `${IAM_SERVER_TENANT_USER_REGIST}/email/verify`;
            const param = {
                code : code,
                email : email
            }
            
            if (Date.now() > expires) {
                alert("초대 링크가 만료되었습니다.");
                navigate("/login");
                return;
            }
            
            axios.post(url, param)
                .then((res) => {
                    if(res.data.code === 200){

                        // 인증코드 검증 성공 확인 후 사용자 이메일 가입 여부 확인 (초대링크 이메일 가입여부 확인)
                        // 미가입시 회원가입 진행
                        // 이미 가입 되어 있는 이메일이라면 로그인 진행
                        // 토큰 데이터 넘기며 회원가입 화면으로 이동
                        axios.post(`${IAM_PATH}/exist`, {unifiedProfileId : email})
                            .then((existRes) => {
                                if(existRes.data.data){
                                    showDialog(
                                        DialogEnum.DEFAULT,
                                        "로그인 안내",
                                        "로그인 후 프로필을 선택해 테넌트 가입을 완료해 주세요."
                                    );
                                    navigate("/login", { state: { email, tenantId, inviter } });
                                }else{
                                    showDialog(DialogEnum.DEFAULT, "확인","회원가입이 필요한 이메일입니다.");
                                    navigate("/register", { state: { email, tenantId, inviter } });
                                }
                            }) 
                    }else{
                        showDialog(DialogEnum.DEFAULT, "오류", "유효하지 않은 초대 링크입니다. \n다시 초대링크를 요청 하세요.");
                        navigate("/login");
                        return;
                    }
                })  
        } catch (e) {
            alert("초대 링크 파싱에 실패했습니다.");
            navigate("/login");
        }



    }, [searchParams, navigate]);

    return <div>초대 정보 확인 중...</div>;
}

export default InvitePage;
